<img :src="svgPath">